var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-columns-section',{staticClass:"card-columns-section-module",attrs:{"columns":_vm.columns}})}
var staticRenderFns = []

export { render, staticRenderFns }